import React from 'react';
import PropTypes from 'prop-types';

const SectionHeader = ({ children, style = {} }) => {
  return (
    <div
      style={{
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: '#333333',
        marginBottom: '16px',
        padding: '8px 0',
        ...style,
      }}>
      {children}
    </div>
  );
};

SectionHeader.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default SectionHeader;
